"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Greater = void 0;
const createMap_1 = require("./factory/createMap");
const Less_1 = require("./Less");
exports.Greater = Object.freeze({
    type: 'greater',
    isLess: false,
    isEqual: false,
    isNotEqual: true,
    isLessOrEqual: false,
    isGreaterOrEqual: true,
    isGreater: true,
    map: (0, createMap_1.createMap)((less, equal, greater) => {
        return greater;
    }),
    get reverse() {
        return Less_1.Less;
    },
    sortResult: 1,
    sortResultReversed: -1,
    valueOf() {
        return 1;
    }
});
